/* globals console, module, require, setTimeout */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    scrollIntoView = require('scroll-into-view-if-needed'),
    _ = require('lodash'),
    // configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    imageError = require('../utilities/imageError'),
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'table'
    },
    collectionRenderCount: 0,
    disabled: false,
    events: {
        'click button':   'onClickButton',
        'click th':       'onClickColumn',
        'click tbody tr': 'onClickRow',
        'click img':      'onClickImage',
        'change select':  'onChangeInputSelect',
        'input input':    'onChangeInputSelect'
    },
    selectedId: null,
    tagName: 'div',
    template: templates.table,
    message: function (message) {
        this.options.message = message;
        // jQuery('#message', this.$el).text(message).toggleClass('d-none', message.length === 0);
    },
    create: function () {
        // reveal the blank form at row 0...
        this.trigger('edit:start');
        this.$el.find('table tbody:eq(0) tr:eq(0)').toggleClass('hidden', false);
        return this.$el.find('table tbody:eq(0) tr:eq(0) form');
    },
    disable: function (disable) {
        this.disabled = disable === true ? true : false;
        this.$el.toggleClass('disabled', disable);
    },
    initialize: function () {
        this.templateContext = {
            title: this.options.title
        };
        // console.log(this.options.emptyMessage);
        this.listenTo(this.collection, 'change update reset sync', _.bind(function (/*collection, x, y, z*/) {
            // console.log('⤵');
            // console.log('reset change (' + this.options.emptyMessage + ')');
            // console.log(x, y, z);
            // console.log('⤴');
            this.$el.find('[data-popover-trigger=true]').popover('hide');
            this.onRender(this.collectionRenderCount++ > 1);
        }, this));
        this.firstTime = true;
    },
    markRow: function (selectedId) {
        // Mark as "selected" the row whose model has the given selectedId.
        this.selectedId = selectedId;
        this.$el.find('tbody tr').removeClass('selected');
        if (this.selectedId) {
            this.$el.find('tbody tr[data-id=' + this.selectedId + ']').each(_.bind(function (i, row) {
                if (this.selectedId === +row.dataset.id) { // sloppy, dataset.id is a string
                    jQuery(row).addClass('selected');
                    scrollIntoView(row, { behavior: 'smooth', scrollMode: 'if-needed' });
                }
            }, this));
        }
    },
    onChangeInputSelect: function (event) {
        if (this.options.statify) {
            this.options.statify(jQuery(event.currentTarget).closest('form'), event.currentTarget.name);
        }
        this.$el.find('[data-action=save]').attr('disabled', false);
        this.trigger('edit:inProgress');
        return false;
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        let form,
            render = true;
        switch (action) {
            case 'cancel':
                // this.trigger('edit:cancel');
                this.trigger('edit:end');
                break;
            case 'delete':
                this.trigger('edit:delete', event.currentTarget.dataset.id);
                this.trigger('edit:end');
                break;
            case 'edit':
                if (this.options.statify) {
                    this.options.statify(jQuery(event.currentTarget).closest('tr').next().find('form'), null);
                }
                jQuery(event.currentTarget).closest('tr').toggleClass('hidden', true).next().toggleClass('hidden', false);
                this.trigger('edit:start');
                render = false;
                break;
            case 'save':
                form = jQuery(event.currentTarget).closest('form');
                if (form[0].checkValidity()) {
                    this.trigger('edit:save', form.serializeArray());
                    this.trigger('edit:end');
                } else {
                    form.toggleClass('was-validated', true);
                    render = false;
                }
                break;
            default:
                console.log('table.onClickButton - action:%s', action);
                break;
        }
        if (render) {
            this.render();
        }
        return false;
    },
    onClickColumn: function (event) {
        const column = jQuery(event.currentTarget),
            attribute = column.attr('name');
        let sortAttribute;
        if (attribute && this.collection.sortAttribute) {
            sortAttribute = this.collection.sortAttribute();
            if (!sortAttribute || sortAttribute.attribute !== attribute) {
                sortAttribute = {attribute: attribute, order: column.data('descending') ? 'descending' : 'ascending'};
            } else {
                sortAttribute.order = sortAttribute.order === 'ascending' ? 'descending' : 'ascending';
            }
            this.collection.sortAttribute(sortAttribute);
        }
        return false;
    },
    onClickImage: function (event) {
        const action = event.currentTarget.dataset.action;
        switch (action) {
            // case 'edit':
            //     if (this.options.statify) {
            //         this.options.statify(jQuery(event.currentTarget).closest('tr').next().find('form'), null);
            //     }
            //     jQuery(event.currentTarget).closest('tr').toggleClass('hidden', true).next().toggleClass('hidden', false);
            //     break;
            default:
                this.trigger(_.snakeCase(action).replace(/_/g, ':'), jQuery(event.currentTarget).closest('tr')[0].dataset.id);
                break;
        }
        // let th elements bubble up to onClickColumn...
        return event.currentTarget.parentElement.tagName === 'TH' ? true : false;
    },
    onClickRow: function (event) {
        if (!this.disabled) {
            this.trigger('select:row', this.collection.get(event.currentTarget.dataset.id));
        }
        return false;
    },
    onRender: function (togglePopovers) {
        const options = {
                title: this.options.title,
                columns: this.collection.columns(),
                rows: this.collection.rows()
            },
            sortAttribute = this.collection.sortAttribute ? this.collection.sortAttribute() : null;
        if (sortAttribute) {
            _.each(options.columns, function (column) {
                if (column.name === sortAttribute.attribute) {
                    column.sort = true;
                    column.order = sortAttribute.order;
                }
            });
        }
        options.message = this.options.message || null;
        if (this.collection.models.length === 0) {
            options.emptyMessage = this.options.emptyMessage || 'missingEmptyMessage';
        }
        this.$el.html(this.template(options));
        jQuery('img.fragile', this.$el).on('error', imageError);
        this.$el.find('input[data-date=true]').datepicker({
                // container: 'div#units',
                autoclose: true,
                format: 'yyyy-mm-dd',
                orientation: 'auto right'
            })
            .on('changeDate', _.bind(this.onChangeInputSelect, this))
            .on('show hide', function () { return false; });
        if (togglePopovers) {
            this.$el.find('[data-toggle=popover]').popover({
                trigger: 'manual'
            });
            this.$el.find('[data-popover-trigger=true]').popover('show');
            setTimeout(_.bind(function () {
                this.$el.find('[data-popover-trigger=true]').popover('hide');
            }, this), 2000);
        }
        this.markRow(this.selectedId);
        return this;
    }
});
